define('lib/backbone/Backbone.Mixins.PodioInfiniteScrollCollection',['require','underscore','jquery','lib/backbone/Backbone.PodioCollection'],function (require) {

  var _ = require('underscore');
  var $ = require('jquery');
  var PodioCollection = require('lib/backbone/Backbone.PodioCollection');

  return {
    itemsPerRequest: 25,      /* how many items will be loaded on each scroll */
    endReached: false,

    loadChunk: function() {
      var self = this;
      var dataLength;
      var dfd = new $.Deferred();

      if (this.endReached) {
        return dfd.resolve();
      }

      return this.fetch({
        data: { offset: this.length, limit: this.itemsPerRequest },
        remove: false,
        sort: false
      }).done(function(responseData) {
        if (responseData.status !== 'error') {
          dataLength = responseData.data.object.length;
          if (!dataLength || dataLength < self.itemsPerRequest) {
            self.endReached = true;
          }
        }
      });
    },

    reset: function() {
      this.endReached = false;
      PodioCollection.prototype.reset.apply(this, _.toArray(arguments));
    }

  };

});

